
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.244 23.382c-.292 0-.583-.111-.805-.333L17.37 18.98a1.12 1.12 0 01-.032-.033l-3.73-3.728-4.83-4.83-.03-.03-3.694-3.696a1.155 1.155 0 01-.033-.032l-4.07-4.07a1.138 1.138 0 011.61-1.61l3.46 3.46a12.436 12.436 0 015.963-1.518 12.408 12.408 0 017.494 2.478 12.459 12.459 0 014.469 6.287c.07.222.07.461 0 .684a12.578 12.578 0 01-4.043 5.952l3.144 3.144a1.138 1.138 0 01-.805 1.943zm-6.32-9.068l2.361 2.361A10.299 10.299 0 0021.662 12 10.202 10.202 0 0012 5.171a10.178 10.178 0 00-4.283.936l1.97 1.97a4.525 4.525 0 012.312-.63c1.217 0 2.36.474 3.22 1.334a4.524 4.524 0 011.333 3.22c0 .826-.218 1.62-.629 2.313zM11.41 9.8l2.79 2.789c.05-.19.076-.388.076-.59 0-.607-.237-1.18-.667-1.61a2.288 2.288 0 00-2.2-.59zm.599 11.305h-.01c-2.718 0-5.304-.857-7.477-2.478a12.46 12.46 0 01-4.47-6.287c-.07-.222-.07-.46 0-.682A12.452 12.452 0 012.01 7.865 1.138 1.138 0 113.825 9.24 10.174 10.174 0 002.338 12 10.202 10.202 0 0012 18.83c.644.002 1.29-.06 1.923-.18a1.138 1.138 0 01.423 2.237c-.77.145-1.555.219-2.337.219z","fill":"#fff"}})])
          )
        }
      }
    